<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Container, Toggle, toast } from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { onMount } from 'svelte';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	let switchSettings = {};
	let loading = {};

	let cache = { ...switchSettings };

	const getSettings = () => {
		Object.keys(settings).forEach((setting) => {
			if (setting.includes('input:') && Number(setting.split(':')[1]) < 100) {
				switchSettings[setting.split(':')[1]] = settings[setting].invert;
				loading[setting.split(':')[1]] = false;
			}
		});
		cache = Object.assign({}, switchSettings);
	};

	const sentRequest = async (inputChannel, event) => {
		switchSettings[inputChannel] = event.target.checked;
		if (JSON.stringify(cache) === JSON.stringify(switchSettings)) return;
		const params = {
			id: inputChannel,
			config: { invert: switchSettings[inputChannel] },
		};

		const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

		if (res.isok) {
			settings[`input:${device.channel}`].invert = switchSettings[inputChannel] =
				event.target.checked;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
			cache = { ...switchSettings };
		} else {
			toast.open({ type: 'danger', title: $format('invert_input_err_toast') });
			switchSettings = { ...cache };
		}
	};
	onMount(() => {
		getSettings();
	});
</script>

{#each Object.keys(switchSettings) as _, i}
	<Container padding="xs" class="mb-s">
		<Toggle
			checked={switchSettings[i]}
			disabled={loading[i]}
			on:click={(e) => sentRequest(i, e)}
			size="m"
			id="toggle-fusp9wp"
			>{$format('invert_switch_label', {
				default: `Invert switch`,
			})}{` ${i}`}</Toggle
		>
	</Container>
{/each}

<!-- <Toggle checked={invert} size="m" on:click={sentRequests} id="toggle-5adr7yz">
	{capFirstChar(
		$format('enable', {
			default: 'Enable'
		})
	)}
</Toggle> -->
